import { createUseStyles } from "react-jss";
import Selector from "../Selector";
import { useState } from "react";

const useStyles = createUseStyles(theme => ({
  settingsItem: {
    marginTop: 10,
    marginBottom: 5,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    "& input": {
      marginLeft: 30,
      height: 30,
      flexShrink: 0,
      width: "50%",
      maxWidth: 300,
      outline: "none",
      "border-radius": 4,
      padding: "3px 9px",
      fontSize: 15,
      border: "1px solid transparent",
      background: theme.colorBackground,
      color: "white",
      fontFamily: "DaytonaPro-Light",
      "&:focus": {
        border: `1px solid ${theme.colorPrimary} !important`,
      },
    },
  },
  infoText: {
    marginTop: "5px",
    color: "#9e9e9e",
    marginBottom: "5px",
    maxWidth: 300,
  },
  dropdown: {
    marginLeft: 30,
    width: "50%",
    position: "relative",
    height: 29,
    display: "flex",
  },
}))

const SelectorField = (props) => {
  const {
    label,
    description,
    onChange,
    value,
    options,
  } = props;
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={classes.settingsItem}>
      <div>
        <label>{label}:</label>
        <p className={classes.infoText}>
          {description}
        </p>
      </div>
      <div className={classes.dropdown}>
        <Selector
          isTeamSelect
          noMaxWidth
          expanded={expanded}
          toggle={() => setExpanded(s => !s)}
          onChange={onChange}
          value={value}
          options={options}
          shouldSortOpts={false}
        />
      </div>
    </div>
  )
}

export default SelectorField;
